
import { css } from "@emotion/react";
import { ReactComponent as QuestionCircle } from "@app/assets/svgs/streamlinehq-question-circle-interface-essential-24 (4).svg";
import { ReactComponent as SettingsIcon } from "@app/assets/svgs/cog.svg";
import { ReactComponent as CertifiedLogo } from "@amplio-common/assets/icons/checkbadge.svg";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import NavIcon from "./NavIcon";
import { currentUser } from "@app/routes/auth/selectors";
import { useDispatch, useSelector } from "react-redux";
import { memo, useMemo, useState } from "react";
import { logout } from "@app/routes/auth/actions";
import NetworkTestDiag from "@app/common/components/NetworkTestDialog";
import SupportDialog from "@app/common/components/SupportDialog";
import ResetPassDialog from "@app/routes/auth/components/password-reset-dialog";
import { BOTTOM_PANNEL_DIALOG_Z_INDEX } from "@app/constants";
import StreamlineIconWrapper from "@app/common/components/StreamlineIconWrapper";
import { getCertificationMap } from "@app/routes/treatment/selectors";
// import PasswordChangeNotification from "@app/routes/auth/components/password-change-notification";
import { useFeature } from "flagged";
import { trackEvent } from "@amplio-common/analytics";
import { Trans } from "@lingui/macro";
import { setIsVoiceSettingsOpen, selectIsVoiceSettingsOpen } from "@app/routes/treatmentV3/store/videoSlice";
import SessionSettingsDialog from "@app/routes/treatmentV3/components/student/SessionSettingsDialog";

const rootStyle = css`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const BottomPanel = () => {
  const dispatch = useDispatch();
  const user = useSelector(currentUser);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isShowSystemCheck, setIsShowSystemCheck] = useState(false);
  const [isShowHelpDialog, setIsShowHelpDialog] = useState(false);
  const [isShowResPassDialog, setIsShowResPassDialog] = useState(false);
  const certificationMap = useSelector(getCertificationMap);
  const hasResetDialog = useFeature("RESET_PASSWORD");
  const isVoiceSettingsOpen = useSelector(selectIsVoiceSettingsOpen);

  const openMenu = !!anchorEl;

  const certTxt = useMemo(() =>
    <div>{certificationMap?.map(crt => <div key={crt.id}>{crt.txt}</div>)}
      <div><Trans>Authorized Curriculum</Trans></div>
    </div> || "", [certificationMap]);

  const toggleLogoutMenu = e => {
    !anchorEl && trackEvent("settings_icon_clicked");
    setAnchorEl(!anchorEl ? e.currentTarget : null);
  };

  const handleLogout = () => {
    dispatch(logout.request());
  };

  const toggleSystemCheckPopUp = () => {
    setIsShowSystemCheck(!isShowSystemCheck);
  };

  const toggleHelpDialog = () => {
    setIsShowHelpDialog(!isShowHelpDialog);
  };

  const toggleResPassDialog = () => {
    if (!isShowResPassDialog) {
      trackEvent("reset_password_chosen");
    } else {
      trackEvent("create_password_window_closed");
    }
    setIsShowResPassDialog(!isShowResPassDialog);
  };

  const toggleVoiceSettings = () => {
    dispatch(setIsVoiceSettingsOpen(!isVoiceSettingsOpen));
  };

  return (
    <div css={rootStyle} data-testid="bottom-bar">
      {certificationMap?.length > 0 && <NavIcon icon={<StreamlineIconWrapper><CertifiedLogo /></StreamlineIconWrapper>} name={certTxt} />}
      <NavIcon icon={<StreamlineIconWrapper><QuestionCircle /></StreamlineIconWrapper>} onClick={toggleHelpDialog} name={<Trans>Help</Trans>} id="Help" />
      <NavIcon icon={<StreamlineIconWrapper><SettingsIcon /></StreamlineIconWrapper>} onClick={toggleLogoutMenu} name={<Trans>Settings</Trans>} id="Settings" />
      {user.id && (
      <div className="menu-wrapper">
        <Menu
          getContentAnchorEl={null}
          anchorEl={anchorEl}
          disableEnforceFocus
          style={{ zIndex: BOTTOM_PANNEL_DIALOG_Z_INDEX }}
          anchorOrigin={{
            horizontal: "right",
            vertical: "bottom",
          }}
          transformOrigin={{
            horizontal: "right",
            vertical: "bottom",
          }}
          PaperProps={{
            style: {
              left: "50%",
              transform: "translateX(8%) translateY(0)",
            },
          }}
          open={openMenu}
          onClose={toggleLogoutMenu}
        >
          {!localStorage.getItem("code_login_token") && (
          <MenuItem data-testid="header-logout-button" disabled>
            {user.name}
          </MenuItem>
          )}
          <MenuItem data-testid="header-logout-button" disabled>
            version: 12
          </MenuItem>

          <MenuItem data-testid="header-voice-settings-button" onClick={toggleVoiceSettings}>
            <span style={{ fontFamily: "'Rubik', sans-serif" }}><Trans>Session settings</Trans></span>
          </MenuItem>

          <MenuItem data-testid="header-logout-button" onClick={toggleSystemCheckPopUp}>
            <span style={{ fontFamily: "'Rubik', sans-serif" }}><Trans>System Check</Trans></span>
          </MenuItem>
          { hasResetDialog && ["credentials"].includes(user.auth_type) && (
            <MenuItem data-testid="header-logout-button" onClick={toggleResPassDialog}>
              <span style={{ fontFamily: "'Rubik', sans-serif" }}><Trans>Reset Password</Trans></span>
            </MenuItem>
          )}
          <MenuItem
            data-testid="header-logout-button"
            onClick={handleLogout}
          >
            <span style={{ fontFamily: "'Rubik', sans-serif" }}><Trans>Logout</Trans></span>
          </MenuItem>
        </Menu>
      </div>
      )}
      { isShowSystemCheck && <NetworkTestDiag closeDialog={toggleSystemCheckPopUp} />}
      { isShowHelpDialog && <SupportDialog closeDialog={toggleHelpDialog} />}
      { isShowResPassDialog && <ResetPassDialog user={user} closeDialog={toggleResPassDialog} />}
      {isVoiceSettingsOpen && <SessionSettingsDialog />}
    </div>
  );
};

export default memo(BottomPanel);
